module.exports = __webpack_public_path__ + "img/02.76365929.png";